<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" loader="dots"></loading>

    <div class="card">
      <div class="card-body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th colspan="4" class="title">任用單</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="width-15 text-right">應聘者</td>
                <td class="width-35">
                  {{ appointmentForm.Name }}
                </td>
                <td class="width-15 text-right">聘用類別</td>
                <td class="width-35">{{ appointmentForm.EmployCategory }}</td>
              </tr>

              <tr>
                <td class="width-15 text-right">任用部門</td>
                <td class="width-35">{{ appointmentForm.AppointmentDepartment }}</td>
                <td class="width-15 text-right">主管承認年資</td>
                <td class="width-35">{{ appointmentForm.AdmitSeniority }}</td>
              </tr>

              <tr>
                <td class="width-15 text-right">最高學歷</td>
                <td class="width-35">
                  {{ appointmentForm.HighestEducation }}
                </td>
                <td class="width-15 text-right">學校 / 科系</td>
                <td class="width-35">
                  {{ appointmentForm.School }} /
                  {{ appointmentForm.Department }}
                </td>
              </tr>

              <tr>
                <td colspan="4" class="title">任用建議</td>
              </tr>

              <tr>
                <td class="text-right">職務</td>
                <td>{{ appointmentForm.PositionName }}</td>
                <td class="text-right">職等</td>
                <td>{{ appointmentForm.Rank }}</td>
              </tr>

              <tr>
                <td class="text-right">試用期薪資</td>
                <td>{{ appointmentForm.ProbationPeriodSalary }}</td>
                <td class="text-right">正式薪資</td>
                <td>{{ appointmentForm.Salary }}</td>
              </tr>

              <tr>
                <td class="text-right">其他特殊說明<br />(含試用期說明)</td>
                <td colspan="3">{{ appointmentForm.Description }}</td>
              </tr>

              <tr>
                <td class="text-right">任用結果</td>
                <td colspan="3">
                  {{ appointmentForm.ApprovalResult }}
                </td>
              </tr>
            </tbody>
          </table>
          <div class="button-wrap center">
            <button
              type="button"
              class="btn btn-secondary mr-1"
              @click="$router.back()"
            >
              返回
            </button>
            <button
              type="button"
              class="btn btn-danger mr-1"
              @click="handleSubmit(sendReviewResult('否決'))"
            >
              否決
            </button>
            <button
              type="button"
              class="btn btn-success mr-1"
              @click="handleSubmit(sendReviewResult('通過'))"
            >
              同意
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="openChoiceSupervisorModal('已簽核')"
            >
              加簽
            </button>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <!-- 送審 Modal -->
    <div
      id="choiceSupervisorModal"
      class="modal fade"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <ValidationObserver
            ref="choiceSupervisor"
            v-slot="{ handleSubmit, reset }"
          >
            <form
              @submit.prevent="handleSubmit(sendSupervisor)"
              @reset.prevent="reset"
            >
              <div class="modal-header">
                <span class="modal-title" id="exampleModalCenterTitle">
                  選擇人員
                </span>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label for="">簽核人員</label>
                  <ValidationProvider
                    class="w-100"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <v-select
                      class="w-100"
                      :options="supervisorOptions"
                      label="Name"
                      placeholder="請選擇"
                      :reduce="(choiceSupervisor) => choiceSupervisor.Guid"
                      v-model="choiceSupervisor"
                    >
                    </v-select>
                    <p v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </div>
                <img class="job-position" src="@/assets/img/query.png" alt="" />
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  {{ i18n("Buttons.Close") }}
                </button>
                <button type="submit" class="btn btn-primary">
                  {{ i18n("Buttons.Confirm") }}
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
export default {
  name: "ReviewAppointmentForm",

  data() {
    return {
      candidate: {},

      //任用單
      appointmentForm: {},

      // 加簽 or 退簽
      supervisorState: null,
      supervisorOptions: [], // 主管列表
      choiceSupervisor: null,
    };
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  methods: {
    // 取得任用單
    getAppointmentForm() {
      const vm = this;
      const api = `${window.endpoints.api}/AppointmentModule/Appointment/${vm.candidate.MatchId}`;

      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200) {
            vm.appointmentForm = response.data;
            vm.$store.dispatch("updateLoading", false);
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "錯誤",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 同意 or 否決 任用單 API
    sendReviewResult(state) {
      const vm = this;
      const api = `${window.endpoints.api}/AppointmentModule/Approve`;

      const data = {
        Id: vm.appointmentForm.Id,
        MatchId: vm.candidate.MatchId,
        Approver: vm.$cookies.get("userId"),
        ApprovalResult: state,
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "成功",
              message: "任用單審核完成",
              type: "success",
              duration: 2500,
            });
            vm.$router.push({
              path: "/manager/recruitment/evaluationhistory",
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "錯誤",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 選擇人員 Modal
    openChoiceSupervisorModal(supervisorState) {
      this.supervisorState = supervisorState;
      this.choiceSupervisor = null;
      this.$refs.choiceSupervisor.reset();
      $("#choiceSupervisorModal").modal("show");
    },

    // 加簽 or 退簽 任用單 API
    sendSupervisor() {
      const vm = this;
      const api = `${window.endpoints.api}/AppointmentModule/AssignApprover`;

      const data = {
        Id: vm.appointmentForm.Id,
        MatchId: vm.candidate.MatchId,
        Approver: vm.$cookies.get("userId"),
        ApprovalResult: vm.supervisorState,
        AssignApprover: vm.choiceSupervisor,
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "成功",
              message: "任用單審核完成",
              type: "success",
              duration: 2500,
            });
            vm.$router.push({
              path: "/manager/recruitment/evaluationhistory",
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "錯誤",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    async getData() {
      const backgroundUser = await this.$api.backgroundUser.getBackgroundUser();

      // 取得主管列表
      this.supervisorOptions = backgroundUser.data.map((user) => {
        return {
          Guid: user.UserId,
          Name: user.Name,
          Email: user.Email,
        };
      });
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  created() {
    this.getData();
    const candidate = JSON.parse(localStorage.getItem("candidate"));
    this.$set(this.candidate, "MatchId", candidate.MatchId);
    this.$set(this.candidate, "Name", candidate.Name);
    this.$set(this.candidate, "Position", candidate.PositionName);
    this.getAppointmentForm();
  },
};
</script>

<style lang="scss" scoped>
.width-15 {
  width: 15%;
}
.width-35 {
  width: 35%;
}

.card {
  margin-top: 20px;
}
.title {
  background-color: #636f83;
  color: #ffffff;
  text-align: center;
  font-weight: bolder;
}
.mark {
  background-color: inherit;
  color: red;
}
.btn-search {
  margin-left: 10px;
}
.go-back {
  margin-top: 20px;
  border: none;
  font-size: 0.8em;
  background-color: #303c50;
  border-radius: 25px;
  padding: 6px 10px;
  color: #fff;
  i {
    margin-right: 5px;
  }
}

#choiceSupervisorModal {
  .modal-body {
    max-height: unset;
    overflow: unset;
  }
  .job-position {
    width: 270px;
    left: -160px;
    bottom: -70px;
    position: relative;
    @media screen and (max-width: 767px) {
      opacity: 0;
    }
  }
}
</style>
